module.exports = __webpack_public_path__ + "img/service-resource-1.2b86beb9.png";